import {
  DeepPartial, AreaSeriesOptions, LayoutOptions, Background, ColorType, ChartOptions,
  CrosshairOptions, PriceScaleOptions, TimeScaleOptions,
} from "lightweight-charts";

import { Series } from "../../models/series";
import { BASIC_COLORS } from "../../models/colors.values";
import { numberFormatters } from "../../../core/formatters";

function getCssVariable(variable: string) {
  return getComputedStyle(document.body).getPropertyValue(variable);
}

export const generationSeriesOption = (s: Series, color: string) => Object.create({
  title: '', priceFormat: { type: 'price', precision: 0 },
  lineColor: color, topColor: color, bottomColor: color, lineWidth: 2,
  pointMaMarkersVisible: false,
  crosshairMarkerVisible: false,
  lastValueVisible: false
}) as DeepPartial<AreaSeriesOptions>

const background: Background = {
  type: ColorType.Solid, color: getCssVariable("--seashell")
}

const layout: DeepPartial<LayoutOptions> = {
  textColor: getCssVariable("--midnight-blue"),
  background,
  fontSize: 12,
  fontFamily: "Inter, sans-serif",
  attributionLogo: false,
}

const crosshair: DeepPartial<CrosshairOptions> = {
  horzLine: {
    visible: true,
    labelVisible: true,
    labelBackgroundColor: BASIC_COLORS.single.color
  },
  vertLine: {
    visible: true,
    labelVisible: false
  }
}

const leftPriceScale: DeepPartial<PriceScaleOptions> = {
  visible: true,
  autoScale: true,
  scaleMargins: {
    top: 0.2,
    bottom: 0
  }
}

const timeScale: DeepPartial<TimeScaleOptions> = {
  visible: true,
  ticksVisible: true
}

export const defaultChartOptions: DeepPartial<ChartOptions> = {
  localization: { priceFormatter: numberFormatters.largeNumber },
  layout,
  rightPriceScale: { visible: false },
  crosshair,
  handleScale: false,
  handleScroll: false,
  grid: {
    horzLines: {
      visible: true,
      color: getCssVariable("--light-grey")
    },
    vertLines: {
      visible: true,
      color: getCssVariable("--light-grey")
    }
  },
  autoSize: true,
  timeScale,
  leftPriceScale
}

export function generateCustomSeriesOptions(priceFormatter: Function, top: number = 0, bottom: number = 0): DeepPartial<ChartOptions> {
  return Object.assign({}, defaultChartOptions, {
    localization: { priceFormatter },
    leftPriceScale: {
      visible: true,
      autoscale: true,
      scaleMargins: {
        top,
        bottom
      }
    }
  })
}

